import { Anchor, AppShell, Flex, Text, UnstyledButton, useMantineColorScheme } from '@mantine/core';
import { UserWidget } from '@/components/UserWidget/UserWidget';
import { EloNavbar } from '@/components/EloNavbar/EloNavbar';
import { Link, useLocation, useNavigation } from 'react-router-dom';
import { ScrollToTop } from '@/utils/ScrollToTop';
import styles from './EloShellLarge.module.css';
import { useEffect } from 'react';
import logoLigth from '@/assets/logo-light.svg';
import logoDark from '@/assets/logo-dark.svg';

import { useTranslation } from 'react-i18next';

export function EloShellLarge(props: any) {
  const { colorScheme } = useMantineColorScheme();
  const headerAndFooterPadding = {
    paddingTop: 'var(--mantine-spacing-sm)',
    paddingBottom: 'var(--mantine-spacing-sm)',
    paddingLeft: 'var(--mantine-spacing-lg)',
    paddingRight: 'var(--mantine-spacing-lg)',
  };

  const navigation = useNavigation();

  const location = useLocation();
  useEffect(() => {
    const main = document.getElementById('main');
    if (!main) return;
    main.className = main.className.replace('fade-out', '');
  }, [location]);

  const { t } = useTranslation();

  return (
    <>
      <ScrollToTop />
      <AppShell
        className={styles[navigation.state === 'loading' ? 'loading' : 'top']}
        header={{ height: 62 }}
        navbar={{
          width: 200,
          breakpoint: 'sm',
          // collapsed: { mobile: !opened },
        }}
        padding="lg"
      >
        <AppShell.Header>
          <Flex align="center" justify="space-between" style={{ ...headerAndFooterPadding }}>
            {/* <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" /> */}
            <UnstyledButton component={Link} to="/" visibleFrom="xs">
              <img style={{ height: '30px' }} src={colorScheme === 'dark' ? logoDark : logoLigth} />
            </UnstyledButton>
            <UserWidget />
          </Flex>
        </AppShell.Header>

        {/* <div
            style={{
              display: 'flex',
              paddingTop: 'calc(var(--app-shell-header-offset, 0rem) + var(--app-shell-padding))',
            }}
          > */}
        <AppShell.Navbar p="md">
          <EloNavbar />
        </AppShell.Navbar>
        <AppShell.Main
          id="main"
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            '--footer-height': '49.8px',
          }}
        >
          <div style={{ marginBottom: 'var(--app-shell-padding)' }}>{props.children}</div>
          <div
            style={{
              marginTop: 'auto',
              marginInlineStart: 'calc(-1 * var(--app-shell-padding))',
              marginInlineEnd: 'calc(-1 * var(--app-shell-padding))',

              marginBottom:
                'calc(-1 * (var(--app-shell-footer-offset, 0rem) + var(--app-shell-padding)))',
              borderTop: '1px solid var(--app-shell-border-color)',
              ...headerAndFooterPadding,
            }}
          >
            <Flex gap={'sm'}>
              <Text>{t('elo_shell_large.rights')}</Text>
              <div style={{ flexGrow: 1 }}></div>
              <Anchor href="https://holaelo.com/elo-hub/privacy">
                {t('elo_shell_large.privacy')}
              </Anchor>
              <Anchor href="https://holaelo.com/elo-hub/terms-and-conditions">
                {t('elo_shell_large.terms')}
              </Anchor>
            </Flex>
          </div>
        </AppShell.Main>
      </AppShell>
    </>
  );
}
